/**
 * 权限检查工具函数
 */

/**
 * 判断用户是否为项目管理员
 * @param currentUser 当前用户信息
 * @returns 是否为项目管理员
 */
export function isProjectAdmin(currentUser?: {
  access?: string;
  primary_role?: string;
  [key: string]: any;
}): boolean {
  if (!currentUser) {
    return false;
  }
  return (
    currentUser.access === 'project_admin' ||
    currentUser.primary_role === 'project_admin'
  );
}

/**
 * 判断用户是否为超级管理员
 * @param currentUser 当前用户信息
 * @returns 是否为超级管理员
 */
export function isSuperAdmin(currentUser?: {
  access?: string;
  primary_role?: string;
  [key: string]: any;
}): boolean {
  if (!currentUser) {
    return false;
  }
  return (
    currentUser.access === 'sys_admin' ||
    currentUser.primary_role === 'sys_admin'
  );
}

/**
 * 判断用户是否为中心管理员
 * @param currentUser 当前用户信息
 * @returns 是否为中心管理员
 */
export function isOrgAdmin(currentUser?: {
  access?: string;
  primary_role?: string;
  [key: string]: any;
}): boolean {
  if (!currentUser) {
    return false;
  }
  return (
    currentUser.access === 'org_admin' ||
    currentUser.primary_role === 'org_admin'
  );
}
